export default "__VITE_ASSET__iZib6cY8__"